import React, { useState } from 'react';
import {
  Card,
  CardActionArea,
  CardMedia,
  Typography,
  CardContent,
} from '@material-ui/core';
import {
  useStyles,
  placeholder,
  CarbonCreditCardLogic,
} from './carbonCreditCard.module';
import ButtonDefault from '../shared/button/button';
import OffsetForm from './OffsetForm';
import NFT from '../../classes/NFT/NFT';

const CarbonCreditCard = (props) => {
  const classes = useStyles();
  const { sendCertificate } = CarbonCreditCardLogic();
  const [showOffsetForm, setShowOffsetForm] = useState(false);
  const handleOffsetClick = () => {
    setShowOffsetForm(true);
  };

  return (
    <div>
      <Card
        className={props.is_sbt ? classes.rootCertificate : classes.rootOffset}
      >
        {showOffsetForm ? (
          <OffsetForm id={props.id} />
        ) : (
          <>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Carbon Credit"
                height="100%"
                image={props.imageCarbonCredit || placeholder}
                title="Carbon Credit"
              />
              <CardContent
                className={
                  props.is_sbt
                    ? classes.containerTextCertificate
                    : classes.containerTextOffset
                }
              >
                <Typography gutterBottom variant="h5" component="h5">
                  {props.name_project} - {props.name}
                </Typography>
                <div>
                  <a
                    href={props.ipfs.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.urlCarbonCredit}
                  >
                    <Typography gutterBottom variant="h5" component="h5">
                      {props.ipfsHash}
                    </Typography>
                  </a>
                  <a
                    href={props.blockchain.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.urlCarbonCredit}
                  >
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h5"
                      style={{ marginBottom: 18 }}
                    >
                      {props.blockchainHash}
                    </Typography>
                  </a>
                  {props.is_sbt ? (
                    <ButtonDefault
                      type="backgroundTurquoise"
                      text={
                        NFT.hasCertificate(props)
                          ? 'VIEW CERTIFICATE'
                          : 'GENERATE CERTIFICATE'
                      }
                      changeView={() => sendCertificate(props.id)}
                    ></ButtonDefault>
                  ) : (
                    <ButtonDefault
                      type="backgroundSoftGreen"
                      text="OFFSET"
                      changeView={() => handleOffsetClick()}
                    ></ButtonDefault>
                  )}
                </div>
              </CardContent>
            </CardActionArea>
          </>
        )}
      </Card>
    </div>
  );
};

export default CarbonCreditCard;
